<template>

  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from '@Sys~/components/mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '450px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null,
      series:[],
      legend:[],
      color:[
        {line:'#FF005A', area:'#f3d0de'}, // 红色
        {line:'#3888fa',area:'#f3f8ff'},  // 蓝色
        {line:'#67C23A', area:'#f0f9eb'}, // 翠绿色
        {line:'#E6A23C', area:'#fff7ea'}, // 土黄色
        {line:'#673ab7', area:'#dcd1f1'}, // 紫色
        {line:'#749f83', area:'#e5f7eb'}, // 绿色
      ],
      animation:['cubicInOut','quadraticOut','cubicInOut','quadraticOut']
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        // console.log('5555',val)
        this.handleData(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart() 
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    // 初始化 eChart图
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.$nextTick(() => {
        // console.log('22222chart数据:',this.chartData)
        this.handleData(this.chartData)
      })
    },

    // 设置eChart 选项 { xAxis, server, datalist} = {}
    setOptions({xaxis, dataList} = {}) {
      this.chart.setOption({
        xAxis: {
          data: xaxis,
          boundaryGap: false,
          axisTick: {
            show: false
          }
        },
        grid: {
          left: 45,
          right: 45,
          bottom: 20,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          }
        },
        legend: {
          formatter:function(name){
             var value = "";
            // console.log('4444:', dataList)
            if(dataList && dataList.length > 0) {
              dataList.forEach(item => {
                if(item.lable == name) {
                  value = item.value
                }
              })
              return name+" : "+value
            } else {
              return name
            }
          }
        },
        series: this.series
      })
    },

    // 处理数据
    handleData(rawData) {
      const server = rawData.server
      // console.log('3333渲染数据：',server)
      const series = []
      server.forEach((item,index) => {
          series.push({
            name: item.lable,
            itemStyle: {
              normal: {
                color: this.color[index].line,
                lineStyle: {
                  color: this.color[index].line,
                  width: 2
                },
                areaStyle: {
                  color: this.color[index].area,
                }
              }
            },
            data: item.value,
            smooth: true,
            type: 'line',
            animationDuration: 2800,
            animationEasing: this.animation[index]
          })
      });
      this.series = series

      this.setOptions(rawData)
    }
  }
}
</script>

